export const RETURN_TO_RESULT = "msTeams.iframe.article.ReturnToResult";
export const THIS_RESOLVED_MY_ISSUE = "msTeams.iframe.article.ThisResolvedMyIssue";
